/* istanbul ignore file */
export enum ErrorMessages {
    pastSiteMaxLimit = "Action disabled. You are over your active site limit.",
    invalidChargeNumber = "Action disabled. Charge number is invalid"
}
